import React, { useEffect, useRef } from "react";
import { Breadcrumb } from "antd";
import { logEvent } from "@Lib/analytics";
import styles from "./index.module.less";
import { setUrlFormat } from "@Lib/common";
import { host } from "@Services/url";

interface IProps {
  brandName: string;
  kindName: string;
}

const VideoBreadcrumb: React.FC<IProps> = ({ brandName, kindName }) => {
  let nav = [
    {
      href: `${host.c}/Models`,
      name: "車款",
      disabled: true,
    },
    {
      href: `${host.c}/Models/${setUrlFormat(brandName)}`,
      name: brandName,
      disabled: true,
    },
    {
      href: `${host.c}/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/Summary.html`,
      name: kindName,
      disabled: true,
    },
    {
      href: "",
      name: "影音詳細頁",
      disabled: true,
    },
  ];

  useEffect(() => {}, []);

  return (
    <section className={styles["VideoBreadcrumb"]}>
      <Breadcrumb separator='>' className={styles["breadcrumb"]}>
        {nav.map((v, i) => (
          <React.Fragment key={i}>
            {v.name !== "" && (
              <Breadcrumb.Item>
                {!!v.href ? (
                  <a href={v.href} target='_blank' className='text-[#ffffff]'>
                    {v.name}
                  </a>
                ) : (
                  <span className='text-[#ffffff]'>{v.name}</span>
                )}
              </Breadcrumb.Item>
            )}
          </React.Fragment>
        ))}
      </Breadcrumb>
    </section>
  );
};

export default VideoBreadcrumb;
